<div class="wm-image" (click)="openScreenshotTool()" [ngClass]="{'canOpenScreenshotTool': allowToOpenScreenshotToolInPopup}">
  @if (displayMode === 'without_draw_canvas' || (displayMode === 'auto' && !hasOverlaysToShow)) {
    <wm-img-tag-based-image
            [downloadable]="downloadable"
            [imageId]="imageId"
            [imageUrl]="imageUrl"
            [small]="small"
            [fillContainer]="fillContainer"
    ></wm-img-tag-based-image>
  } @else {
    <wm-canvas-based-image #canvasImage
            [downloadable]="downloadable"
            [imageId]="imageId!"
            [imageUrl]="imageUrl"
            [small]="small"
            [fillContainer]="fillContainer"
            [showOverlays]="showOverlays"
            [infoItems]="infoItems"
            [additionalOverlays]="additionalOverlays"
            [overlayHandlesFor]="overlayHandlesFor"
            [scale]="scale"
            [editable]="editable"
            (error)="error.emit($event)"
            (overlayHit)="overlayHit.emit($event)"
    ></wm-canvas-based-image>
  }
</div>
